import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
//import { VclStepsModule } from '@voxel/community';
import { HeaderComponent } from './header/header.component';
import {
  VoxelDialogModule,
  VoxelModalModule,
  VoxelTabsModule,
  VoxelIconModule,
  VoxelButtonModule
} from '@voxel/components';

import { StepperComponent } from './stepper/stepper.component';

import { VoxelProgressBarModule } from '@voxel/components/ids';

/**
 * Configuración de los modulos de voxel
 *
 * *Voxel modules config*
 */
const voxelModules: Array<any> = [
  VoxelDialogModule,
  VoxelModalModule,
  VoxelTabsModule,
  VoxelIconModule,
  VoxelButtonModule,
  VoxelProgressBarModule
];

/**
 * Configuración de los modulos de voxel community
 *
 * *voxel community modules config*
 */
const voxelCommunityModules: any[] = [
  //VclStepsModule,
];

@NgModule({
  imports: [
    CommonModule,
    ...voxelCommunityModules,
    ...voxelModules
  ],
  exports: [
    HeaderComponent,
    StepperComponent,
    ...voxelCommunityModules,
    ...voxelModules
  ],
  providers: [],
  declarations: [
    HeaderComponent,
    StepperComponent
  ],
})

export class SharedComponentsModule { }
